// TODO: Combine Scent update into one API call using sections API
class VariantUpdater {
  static VARIANTS_METAFIELDS_CACHE = null;

  constructor(variantId) {
    this.variantId = variantId;
  }

  static isVariantImageEnabled() {
    const variantImageElement = document.querySelector('[data-is-variant-image-enable]');
    return variantImageElement && variantImageElement.getAttribute('data-is-variant-image-enable') === 'true';
  }

  static async updateWhyToBuySection(variantInformation){
    const whyToBuyText = variantInformation['why_to_buy'];
    const isText = Boolean(whyToBuyText);

    const $whyToBuySection = document.querySelector('[why-to-buy-section]');
    if($whyToBuySection){
      $whyToBuySection.querySelector('[why-to-buy-text]').innerHTML = whyToBuyText;
      $whyToBuySection.classList.toggle('hidden', !isText)
    }
  }

  static async updateSEOInformation(variantInformation, variantDefaults, variantId){
    const metaTitle = variantInformation['meta_title'] || variantDefaults['meta_title'];
    const metaDescription = variantInformation['meta_description'] || variantDefaults['meta_description'];
    
    document.title = metaTitle;
    const metaDescriptionElement = document.querySelector('meta[name="description"]')
    if(metaDescriptionElement){
      metaDescriptionElement.setAttribute('content', metaDescription);
    }
    const canonicalElement = document.querySelector('link[rel="canonical"]');
    if(canonicalElement){
      const currentCanonicalValue = canonicalElement.getAttribute('href');
      canonicalElement.setAttribute('href', currentCanonicalValue.replace(/variant=[0-9]+/, `variant=${variantId}`) )
    }
  }

  static async updateVariantTitle(variantInformation, variantDefaults, product){
    const handle = product['handle'];
    const options = product['options'];
    const productTitle = product['title'];
    
    const metaScentName = variantInformation['scent'] || false;
    let secondTitle = variantInformation['option_2'] || false;
    let prefixTitle = '';
    const isSecondOptionBenefit = (options[1] ?? '') == 'Benefit';

    //updating scent title
    if(handle == 'whole-body-deodorant' && secondTitle == 'Stick'){
      prefixTitle = 'Sensitive';
    }
    else if(isSecondOptionBenefit){
      prefixTitle = secondTitle;
      secondTitle = '';
      if(productTitle.includes('Moisturizer') && prefixTitle == 'Moisturizing'){
        prefixTitle = ''
      }
    }

    document.querySelectorAll('[scent-title]').forEach($scentTitle => {
      if(metaScentName){
        $scentTitle.classList.remove('hidden');
        $scentTitle.innerText = metaScentName;
      }
      else{
        $scentTitle.classList.add('hidden');
      }
    });

    document.querySelectorAll('[product-title-prefix]').forEach($productPrefixTitle => {
      $productPrefixTitle.innerText = prefixTitle;
      $productPrefixTitle.classList.toggle('hidden', !prefixTitle);
    });

    document.querySelectorAll('[variant-title]').forEach($variantTitle => {
      if(secondTitle){
        $variantTitle.classList.remove('hidden');
        $variantTitle.innerText = secondTitle
      }else{
        $variantTitle.classList.add('hidden');
        $variantTitle.innerText = '';
      }
    });

    const scentFamilyElement = document.querySelector('.product-section-scent-family');
    if(scentFamilyElement){
      scentFamilyElement.innerText = scentFamily;
    }
  }

  static updateVariantMetaInformation(variantId){
    if (!variantId) {
      console.warn('updateVariantMetaInformation(n: variantId is not provided or invalid.');
      return; // Early exit if variantId is null, undefined, or invalid
    }

    VariantUpdater.getVariantsMetaInformation().then(variantsMetafields => {
      const variantInformation = variantsMetafields[variantId];
      const variantDefaults = variantsMetafields['default'];
      const product = variantsMetafields['product'];

      VariantUpdater.updateWhyToBuySection(variantInformation);
      VariantUpdater.updateSEOInformation(variantInformation, variantDefaults, variantId);
      VariantUpdater.updateVariantTitle(variantInformation, variantDefaults, product);
    }).catch(error => {
      throw error
    });
  }

  static async getVariantsMetaInformation(){
    if(VariantUpdater.VARIANTS_METAFIELDS_CACHE !== null){
      return VariantUpdater.VARIANTS_METAFIELDS_CACHE;
    }
    return fetch(document.location.pathname + "?sections=variants-metafields")
      .then(res =>  res.json()).then(sections => {
        if(sections['variants-metafields']){
          const container = document.createElement('div');
          container.innerHTML = sections['variants-metafields']
          VariantUpdater.VARIANTS_METAFIELDS_CACHE = JSON.parse(container.querySelector('div').innerText);
        }
        return VariantUpdater.VARIANTS_METAFIELDS_CACHE
      });
  }
}